export default __webpack_public_path__ + "static/media/svg-8.2de63fe0.svg";